import styled from 'styled-components';
import { colors, globalImages, shadows } from '../../styles/GlobalStyles';

export const IntroLayoutWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: url(${globalImages.introBackground});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 200px;
  gap: 100px;

  h1 {
    font-style: normal;
    font-weight: 650;
    font-size: 100px;
    line-height: 99%;
    letter-spacing: 0.02em;
    text-transform: uppercase;

    background: linear-gradient(270deg, #00c6e9 -0.01%, #090d34 99.99%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    margin-bottom: 30px;
  }

  h2 {
    font-style: normal;
    font-weight: 350;
    font-size: 36.727px;
    line-height: 48px;
    letter-spacing: -0.01em;
    color: ${colors.primary900};
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 50px 20px;
    gap: 20px;

    h1 {
      font-size: 35px;
      text-align: center;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 20px;
    }
  }
`;

export const IntroLayoutBody = styled.div`
  flex: none;
  width: 500px;
  background: ${colors.neutral0}D9;
  border-radius: 20px;
  padding: 40px;
  box-shadow: ${shadows.shadowXS};
  backdrop-filter: blur(3.75px);

  @media (max-width: 1000px) {
    width: 100%;
    padding: 20px;
  }
`;
